import styled from 'styled-components';

export const StyledAppWrapper = styled.div`
  border-radius: 2px;
  transition: 0.2s all ease-in-out;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  margin: auto;
  ${({ isComponentWithoutScroller }: { isComponentWithoutScroller: any }) =>
    isComponentWithoutScroller ? 'height: calc(100vh - 16px)' : 'height: calc(100vh - 75px)'};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  overflow-x: auto;
`;
